import api from '@/lib/api/axios'

export interface PopulatePermissionsResponse {
    success: boolean
    data: {
        message: string
        permissionsCreated: number
        permissionsUpdated: number
        roleLinksCreated: number
        roleLinksSkipped: number
        rolesProcessed: Array<{
            roleName: string
            assigned: number
            skipped: number
        }>
    }
    message: string
}

export const adminApi = {
    populatePermissions: () =>
        api.post<PopulatePermissionsResponse>('/api/admin/populate-permissions'),
}
